import { ShortSpecification } from '@components/display/offer/ShortSpecifications'

import styles from 'styles/OfferShortSpecifications.module.css'
import stylesAlt from 'styles/OfferShortSpecificationsAlt.module.css'

const ShortSpecificationsAlt = ({ offer: { service_kind }}) => {
    return (
        <div className={`${styles.specs} ${stylesAlt.specs}`}>
            <ShortSpecification value={service_kind} alt="Rodzaj" showtext={true} />
        </div>
    )
}

export default ShortSpecificationsAlt